import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { keyframes } from "@emotion/react";
import { CheckIcon } from "@radix-ui/react-icons";
import { fontSize, iconSize } from "../../../../../core/design-system/index.js";
import { Container } from "../../../components/basic.js";
import { StyledDiv } from "../../../design-system/elements.js";
export function StepIcon(props) {
    return (_jsx(Container, { flex: "row", center: "both", color: props.isDone
            ? "success"
            : props.isActive
                ? "accentText"
                : "secondaryText", children: _jsx(Circle, { children: props.isDone ? (_jsx(CheckIcon, { width: iconSize.sm, height: iconSize.sm })) : (_jsx(PulsingDot, { "data-active": props.isActive })) }) }));
}
export function Step(props) {
    return (_jsxs(Container, { flex: "row", center: "y", gap: "xs", style: {
            fontSize: fontSize.sm,
        }, color: props.isDone
            ? "success"
            : props.isActive
                ? "accentText"
                : "secondaryText", children: [_jsx(StepIcon, { isDone: props.isDone, isActive: props.isActive }), props.label] }));
}
const pulseAnimation = keyframes `
0% {
  opacity: 1;
  transform: scale(0.5);
}
100% {
  opacity: 0;
  transform: scale(1.5);
}
`;
const PulsingDot = /* @__PURE__ */ StyledDiv(() => {
    return {
        background: "currentColor",
        width: "9px",
        height: "9px",
        borderRadius: "50%",
        '&[data-active="true"]': {
            animation: `${pulseAnimation} 1s infinite`,
        },
    };
});
const Circle = /* @__PURE__ */ StyledDiv(() => {
    return {
        border: "1px solid currentColor",
        width: "20px",
        height: "20px",
        borderRadius: "50%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
    };
});
//# sourceMappingURL=Stepper.js.map